import { getHasInstantBrochures } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { ToggleEnquiryFormButtonAura } from '@bridebook/web/app-basic/components/supplier/toggle-enquiry-form-button-aura';
import { cn, Flex, Text } from '@bridebook/aura';
import { useIsVenueProfileV2 } from '@bridebook/web/app-basic/components/supplier/hooks/use-is-venue-profile-v2';

const BrochureWell = () => {
  const { t } = useTranslation('supplier');
  const hasInstantBrochures = useSelector(getHasInstantBrochures);
  const isVenueProfileV2 = useIsVenueProfileV2();

  return (
    <div data-name="brochure-well-wrapper" className="w-full">
      {hasInstantBrochures ? (
        <Flex className="justify-between gap-2 bg-indigo-crush-04 px-5 py-6">
          <Flex className="flex-col">
            <Text variant="typo-base-semibold" className="text-indigo-crush">
              {t('supplierBrochureWell.title')}
            </Text>
            <Text variant="typo-sm" className="text-space-75">
              {t('supplierBrochureWell.subtitle')}
            </Text>
          </Flex>
          <ToggleEnquiryFormButtonAura contactMethod="supplierProfile_topButtonDownloadable" />
        </Flex>
      ) : (
        <div className={cn('px-4', !isVenueProfileV2 && 'lg:px-0')}>
          <ToggleEnquiryFormButtonAura
            contactMethod="supplierProfile_topButton"
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};

export default BrochureWell;
